import { render, staticRenderFns } from "./BtnAddEditSchool.vue?vue&type=template&id=2bd17532&"
import script from "./BtnAddEditSchool.vue?vue&type=script&lang=js&"
export * from "./BtnAddEditSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports